import { theme } from '../../theme';

export const rowExpandedStyle = () => {
  return {
    background: theme.palette.common.white,
    marginBottom: '0px',
  };
};
